import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';

export type EmailProvider = 'gmail' | 'outlook' | 'default';

@Component({
  selector: 'provider-modal',
  templateUrl: './provider-modal.component.html',
  styleUrls: ['./provider-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProviderModalComponent implements AfterViewInit {
  @Input() open = false;
  @Input() title = 'Select Email Provider';
  @Output() selected = new EventEmitter<EmailProvider | 'cancel'>();
  @ViewChild('firstFocusable') firstFocusable?: ElementRef<HTMLButtonElement>;

  ngAfterViewInit(): void {
    this.tryFocus();
  }

  onBackdrop(): void {
    this.selected.emit('cancel');
  }

  onCancel(): void {
    this.selected.emit('cancel');
  }

  onSelect(provider: EmailProvider): void {
    this.selected.emit(provider);
  }

  private tryFocus(): void {
    if (this.open && this.firstFocusable?.nativeElement) {
      requestAnimationFrame(() => this.firstFocusable!.nativeElement.focus());
    }
  }
}
